var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"roma-breadcrumbs"},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.breadcrumbs),function(item,index){return _c('span',{key:item.text},[_c('router-link',{style:({ 
          color: !item.disabled ? '#6B6B6B' : '#1A161B', 
          textDecoration: 'none',
          fontSize: '14px',
          fontWeight: '500'
        }),attrs:{"to":{ path: !item.disabled ? item.href: ''}}},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")]),(index<_vm.breadcrumbs.length-1)?_c('span',[_c('chevron-right-icon',{staticClass:"neutro1-icon",staticStyle:{"padding-top":"3px"},attrs:{"size":"1x"}})],1):_vm._e()],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }